import { logAndylitics, log, logAPI } from "./andyliticsApi";
import * as tools from "../helpers/Tools";


const BASE_URL = typeof window !== 'undefined' ? window.serverData.data.phyndApibaseUrl : '';
const CLIENT_ID = "MyBSWHealth.Web";


/**
 * Returns mapped visit types and locations. Does not return slots. 
 * 
 * SearchModel required properties:
 * - providerId
 * - providerIdType     NPI or EpicID
 * - scheduleType       OpenSchedule or DirectSchedule
 * - authorization      bearer token valid ONLY for DirectSchedule
 * 
 * Optional:
 * - friendlyUrl        required if not using providerId
 * 
 * @param {any} searchModel search parameters
 * @returns {any} visit types and locations.
 */
export const getVisitTypeAndLocationForProvider = (searchModel, enableNewProviderSchedulingWorkflow) => {
    const queryString = modelToQueryString(searchModel);
    const fullUrl = (searchModel.scheduleType !== "DirectSchedule" && enableNewProviderSchedulingWorkflow) ? `${BASE_URL}V3/Scheduling/GetVisitTypeAndLocationForProvider?${queryString}` : `${BASE_URL}V2/Scheduling/GetVisitTypeAndLocationForProvider?${queryString}` ;
    const params = {
        headers: {
            "x-bsw-clientid": CLIENT_ID,
            "accept": "application/json"
        },
        method: "GET"
    };

    if (searchModel.scheduleType === "DirectSchedule" && searchModel.authorization) {
        params.headers.authorization = `bearer ${searchModel.authorization}`;
    }

    //const request = new Request(fullUrl, params);
    var start = new Date();
    
    return fetch(fullUrl, params).then(response => {
        logAPI("MBHWeb.Api.Schedule.Open.GetProviderVisitTypeAndLocation", start, fullUrl);
        return response.json();
    }).catch(err => { console.log("GetVisitTypeAndLocation api Error", err); logAPI("MBHWeb.Api.Schedule.Open.GetProviderVisitTypeAndLocationMBHWeb.LogError.Post.Failure", start, fullUrl, err); return Promise.reject(err); });
};


/**
 * Returns schedule slots for the given provider.
 * 
 * SearchModel required properties:
 * - start
 * - end
 * - providerId
 * - providerIdType     NPI or EpicID
 * - scheduleType       OpenSchedule or DirectSchedule
 * - visitTypeId
 * - authorization      bearer token ONLY valid for DirectSchedule
 * 
 * Optional:
 * - locationId
 * - departmentId
 * - patientId          required for DirectSchedule
 * - loginId            required for DirectSchedule
 * 
 * @param {any} searchModel search parameters
 * @returns {any} open schedule slots
 */
export const getScheduleForProvider = (searchModel,  isMammogramSchedule = false) => {

    if (searchModel.start.indexOf(" ")) {
        searchModel.start = searchModel.start.split(" ")[0];
    }
    if (searchModel.end.indexOf(" ")) {
        searchModel.end = searchModel.end.split(" ")[0];
    }

    const queryString = modelToQueryString(searchModel);
    const fullUrl = isMammogramSchedule ? `${BASE_URL}V3/Services/GetScheduleForProvider?${queryString}`:`${BASE_URL}V2/Scheduling/GetScheduleForProvider?${queryString}`;
    //const fullUrl = `${BASE_URL}V2/Scheduling/GetScheduleForProvider?${queryString}`;

    const params = {
        headers: {
            "x-bsw-clientid": CLIENT_ID,
            "accept": "application/json"
        },
        method: "GET"
    };

    if (searchModel.scheduleType === "DirectSchedule" && searchModel.authorization) {
        params.headers.authorization = `bearer ${searchModel.authorization}`;
    }
    var start = new Date();
    //const request = new Request(fullUrl, params);
    return fetch(fullUrl, params).then(response => {
        if (!response.ok) {
            //throw Error(response.statusText);
            logAPI("MBHWeb.Api.Schedule.Open.GetProviderSchedule.FAILED", start, fullUrl);
        }
        return response;
    }).then(response => {
        logAPI("MBHWeb.Api.Schedule.Open.GetProviderSchedule", start, fullUrl);
        return response.json();
    });
};


/**
 * Returns the first day with available slots for the given provider.
 * 
 * SearchModel required properties:
 * - providerId
 * - providerIdType     NPI or EpicID
 * - scheduleType       OpenSchedule or DirectSchedule
 * - visitTypeId
 * - departmentId
 * - authorization      bearer token ONLY valid for DirectSchedule
 * 
 * Optional:
 * - patientId          required for DirectSchedule
 * - loginId            required for DirectSchedule
 * 
 * @param {any} searchModel search parameters
 * @returns {any} provider schedule
 */
export const getEarliestScheduleForProvider = (searchModel) => {

    const queryString = modelToQueryString(searchModel);
    const fullUrl = `${BASE_URL}V2/Scheduling/GetEarliestScheduleForProvider?${queryString}`;
    const params = {
        headers: {
            "x-bsw-clientid": CLIENT_ID,
            "accept": "application/json"
        },
        method: "GET"
    };

    if (searchModel.scheduleType === "DirectSchedule" && searchModel.authorization) {
        params.headers.authorization = `bearer ${searchModel.authorization}`;
    }
    var start = new Date();
    //const request = new Request(fullUrl, params);
    return fetch(fullUrl, params).then(response => {
        logAPI("MBHWeb.Api.Schedule.Open.GetEarliestProviderSchedule", start, fullUrl);
        return response.json();
    }).catch(err => { logAPI("MBHWeb.Api.Schedule.Open.GetEarliestProviderSchedule.Failure", start, fullUrl, err); return Promise.reject(err); });
};


export const getArrivalTime = (searchModel) => {

    const queryString = modelToQueryString(searchModel);
    const fullUrl = `${BASE_URL}/V3/Services/GetArrivalTime?${queryString}`;
    const params = {
        headers: {
            "x-bsw-clientid": CLIENT_ID,
            "accept": "application/json"
        },
        method: "GET"
    };
    var start = new Date();
    //const request = new Request(fullUrl, params);
    return fetch(fullUrl, params).then(response => {
        logAPI("MBHWeb.Api.Schedule.Open.GetArrivalTime", start, fullUrl);
        return response.json();
    }).catch(err => { logAPI("MBHWeb.Api.Schedule.Open.GetArrivalTime.Failure", start, fullUrl, err); return Promise.reject(err); });
};



/**
 * Returns a list of providers the user has visited before.
 * 
 * SearchModel required properties:
 * - loginId
 * - patientId
 * - patientIdType
 * - authorization
 * 
 * @param {any} searchModel search parameters
 * @returns {any} list of providers
 */
export const getProvidersList = (searchModel) => {
    const queryString = modelToQueryString(searchModel);
    const fullUrl = `${BASE_URL}V2/Scheduling/GetProvidersList?${queryString}`;
    const params = {
        headers: {
            "x-bsw-clientid": CLIENT_ID,
            "accept": "application/json",
            "authorization": `bearer ${searchModel.authorization}`
        },
        method: "GET"
    };
    var start = new Date();
    //const request = new Request(fullUrl, params);
    return fetch(fullUrl, params).then(response => {
        logAPI("MBHWeb.Api.Schedule.Open.GetProviderList", start, fullUrl);
        return response.json();
    }).catch(err => { logAPI("MBHWeb.Api.Schedule.Open.GetProviderList.Failure", start, fullUrl, err); return Promise.reject(err); });
};

/// to load Questionnaire mammogram questions
export const loadQuestionByVisitType = (searchModel) => {
    const queryString = modelToQueryString(searchModel);
    const fullUrl = `${BASE_URL}V3/Services/LoadQuestionsByVisitType?${queryString}`;
    const params = {
        headers: {
            "x-bsw-clientid": CLIENT_ID,
            "accept": "application/json",
            "authorization": `bearer ${searchModel.authorization}`
        },
        method: "GET"
    };
    var start = new Date();
    //const request = new Request(fullUrl, params);
    return fetch(fullUrl, params).then(response => {
        logAPI("MBHWeb.Api.Schedule.Open.LoadQuestionByVisitType", start, fullUrl);
        return response.json();
    }).catch(err => { logAPI("MBHWeb.Api.Schedule.Open.LoadQuestionByVisitType.Failure", start, fullUrl, err); return Promise.reject(err); });
};

//For Questionnaire mammogram questions respone validation
export const getResponseForMammoQuestions = (model, token) => {
    const url = encodeURI(`${BASE_URL}V3/Services/ValidateQuestionForVisitType`);
    let body = model;
    if (body.authorization) { delete body.authorization; }
    const params = {
        headers: {
            "x-bsw-clientid": CLIENT_ID,
            "accept": "application/json",
            "content-type": "application/json"
        },
        body: JSON.stringify(body),
        method: "POST"
    };
    
   if (token) {
       params.headers.authorization = `bearer ${token}`;
   }
    const start = new Date();
    return fetch(url, params).then(response => {
        logAPI("MBHWeb.Api.Schedule.GetResponseForMammoQuestions", start, url, model);
        if (response && response.status && response.status === 200) {
            return response.json();
        }
        else return response;
    }).catch(err => { 
        logAPI("MBHWeb.Api.Schedule.Open.GetResponseForMammoQuestions.Get.Failure", start, url, JSON.stringify(err));
        return Promise.reject(err); });
};

// to save Questionnaire mammogram questions respone to EPIC

export const saveQuestionsResponse = (model, token) => {
    const url = encodeURI(`${BASE_URL}/V3/Services/SaveQuestionsToEpic`);
    let body = model;
    if (body.authorization) { delete body.authorization; }
    const params = {
        headers: {
            "x-bsw-clientid": CLIENT_ID,
            "accept": "application/json",
            "content-type": "application/json"
        },
        body: JSON.stringify(body),
        method: "POST"
    };
    
   if (token) {
       params.headers.authorization = `bearer ${token}`;
   }
    const start = new Date();
    return fetch(url, params).then(response => {
        logAPI("MBHWeb.Api.Schedule.saveQuestionsResponse", start, url, model);
        if (response && response.status && response.status === 200) {
            return response.json();
        }
        else return response;
    }).catch(err => { 
        logAPI("MBHWeb.Api.Schedule.Open.saveQuestionsResponse.Get.Failure", start, url, JSON.stringify(err));
        return Promise.reject(err); });
};

export const getProvidersListv3 = (searchModel, token) => {
    const start = new Date();
    const fullUrl = `${BASE_URL}v3/Epic/GetProvidersList?epicProvidersRequest.loginId=${encodeURIComponent(searchModel.loginId)}&epicProvidersRequest.proxyPatientId=${searchModel.proxyPatientId}&epicProvidersRequest.proxyPatientIdType=EXTERNAL`;
    const params = {
        headers: {
            "x-bsw-clientid": CLIENT_ID,
            "accept": "application/json",
            "Authorization": `bearer ${token}`
        },
        method: "GET"
    };

    return fetch(fullUrl, params)
        .then(response => {
            logAPI("MBHWeb.Api.Schedule.Open.ProvidersListv3.Get", start, fullUrl);
            return response.json();
        })
        .catch(error => {
            logAPI("MBHWeb.Api.Schedule.Open.ProvidersListv3.Get.Failure", start, fullUrl, JSON.stringify(error));
            return Promise.reject(error);
        });
};
/**
 * Returns the daily availability for a provider for a given month. If month is not specified, six months are returned.
 * 
 * SearchModel required properties:
 * - providerId
 * - providerIdType     NPI or EpicID
 * - scheduleType       OpenSchedule or DirectSchedule
 * - visitTypeId
 * - authorization      bearer token ONLY valid for DirectSchedule
 * 
 * Optional:
 * - locationId
 * - departmentId
 * - month              valid values are January, February, March, April, May, June, July, August, September, October, November, December
 * 
 * @param {any} searchModel search parameters
 * @returns {any} provider availability
 */
export const getMonthlyAvailability = (searchModel) => {

    const queryString = modelToQueryString(searchModel);
    const fullUrl = `${BASE_URL}V2/Scheduling/GetMonthlyAvailability?${queryString}`;
    const params = {
        headers: {
            "x-bsw-clientid": CLIENT_ID,
            "accept": "application/json"
        },
        method: "GET"
    };

    if (searchModel.scheduleType === "DirectSchedule" && searchModel.authorization) {
        params.headers.authorization = `bearer ${searchModel.authorization}`;
    }
    var start = new Date();
    //const request = new Request(fullUrl, params);
    return fetch(fullUrl, params).then(response => {
        logAPI("MBHWeb.Api.Schedule.Open.GetMonthlyAvailability", start, fullUrl);
        return response.json();
    }).catch(err => { logAPI("MBHWeb.Api.Schedule.Open.GetMonthlyAvailability.Failure", start, fullUrl, err); return Promise.reject(err); });
};



/**
 * Schedules an appointment. If schedule type is direct, pass in the client's OAuth token.
 * 
 * Schema for the posted model:
       {
          "loginId": "string",
          "myChartId": "string",
          "proxyPatientId": "string",
          "proxyPatientIdType": "string",
          "visitTypeId": "string",
          "visitTypeIdType": "string",
          "providerId": "string",
          "providerIdType": "string",           // ie, ProviderNPI
          "departmentId": "string",
          "departmentIdType": "string",
          "date": "string",                     // format YYYY-MM-DD
          "time": "string",                     // format HH:MM:SS
          "comments": "string"
        }
 * 
 * @param {any} model schedule model
 * @param {any} token oauth token required only for DirectSchedule
 * @returns {any} ??
 */
export const scheduleAppointment = (model, token, callLatest = false, isMammogramSchedule = false) => {
    const fullUrl = getScheduleUrl(callLatest, isMammogramSchedule, model.scheduleType);

    let body = model;
    if (body.authorization) { delete body.authorization; }
    if (body.scheduleType) { delete body.scheduleType; }

    const params = {
        headers: {
            "x-bsw-clientid": CLIENT_ID,
            "accept": "application/json",
            "content-type": "application/json"
        },
        body: JSON.stringify(body),
        method: "POST"
    };
    
    if (token) {
        params.headers.authorization = `bearer ${token}`;
    }


    var start = new Date();
    //const request = new Request(fullUrl, params);
    
    return fetch(fullUrl, params).then(response => {
        // comments contains PHI: removing it before logging...
        model.comments = "<<masked>>";
        logAPI("MBHWeb.Api.Schedule.Appointment", start, fullUrl, model);
        return response.json();
    }).catch(err => {
        model.comments = "<<masked>>";
        logAPI("MBHWeb.Api.Schedule.Appointment.Failure", start, fullUrl, { error: err, model: model });
        return Promise.reject(err);
    });
};


/**
 * Creates a patient in Epic for open scheduling. If a patient already exists, it will be returned along with a loginId.
 * 
 * Schema for the posted model:
       {
          "email": "string",
          "firstName": "string",
          "lastName": "string",
          "title": "string",
          "suffix": "string",
          "nationalIdentifier": "string",
          "dateOfBirth": "2019-02-11T13:50:29.549Z",
          "gender": "string",
          "departmentId": "string",
          "departmentIdType": "string",
          "maritalStatus": "string",
          "race": "string",
          "religion": "string",
          "houseNumber": "string",
          "streetLine1": "string",
          "streetLine2": "string",
          "city": "string",
          "state": "string",
          "zipCode": "string",
          "county": "string",
          "country": "string",
          "phoneNumbers": [
            {
              "number": "string",
              "type": "string"
            }
          ]
        }
 * 
 * @param {any} model patient model.
 * @param {any} token user token.
 * @returns {any} patient info
 */
export const createPatient = (model, token) => {
    const fullUrl = encodeURI(`${BASE_URL}V2/Scheduling/CreatePatient`);
    const params = {
        headers: {
            "x-bsw-clientid": CLIENT_ID,
            "accept": "application/json",
            "content-type": "application/json"
        },
        body: JSON.stringify(model),
        method: "POST"
    };

    if (token) {
        params.headers.authorization = `bearer ${token}`;
    }

    var start = new Date();
    //const request = new Request(fullUrl, params);

    return fetch(fullUrl, params).then(response => {
        logAPI("MBHWeb.Api.Schedule.CreatePatient", start, fullUrl, model);
        return response.json();
    }).catch(err => { logAPI("MBHWeb.Api.Schedule.CreatePatient.Failure", start, fullUrl, err); return Promise.reject(err); });
};

/**
 * Converts the contents of a model to querystring parameters.
 * 
 * @param {any} model the model to convert
 * @returns {string} the resulting querystring.
 */
const modelToQueryString = (model) => {
    const queryString = [];
    for (var property in model) {
        if (typeof model[property] !== "string" || (model[property] !== "" && property.toLowerCase() !== "authorization")) {
            queryString.push(`${property}=${encodeURIComponent(model[property])}`);
        }
    }

    return queryString.length > 0 ? queryString.join("&") : "";
};

/**
 * Converts the contents of a model to querystring parameters.
 * 
 * @param {any} callLatest the model to convert
 * @returns {string} the resulting url.
 */
 const getScheduleUrl = (callLatest, isMammogramSchedule,  scheduleType) => {
    const url = isMammogramSchedule ? 
                `${BASE_URL}V3/Services/ScheduleAppointment` : callLatest ? 
                `${BASE_URL}V3/Scheduling/ScheduleAppointment` : `${BASE_URL}V2/Scheduling/ScheduleAppointment`;
    const fullUrl = scheduleType !== "DirectSchedule" ? encodeURI(`${url}?scheduleType=OpenSchedule`) : encodeURI(`${url}?scheduleType=DirectSchedule`);
    return fullUrl;  
};
